// extracted by mini-css-extract-plugin
module.exports = {"textArea":"styles_textArea__Fh_g8","resizable":"styles_resizable__nZIi9","hasError":"styles_hasError___u5YC"};